"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocationsMapUrl = void 0;
var _alloyProvider = require("@adsk/alloy-provider");
var _react = require("react");
var _getAccHostname = require("../utils/browser/getAccHostname");
const useLocationsMapUrl = _ref => {
  let {
    issueId,
    mode
  } = _ref;
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  return (0, _react.useMemo)(() => {
    const path = "https://".concat((0, _getAccHostname.getAccHostname)(), "/locations/projects/").concat(projectId, "/map");
    let search = "?entityType=issues";
    if (issueId) {
      search += "&selectedEntityId=".concat(issueId);
    }
    if (mode) {
      search += "&mode=".concat(mode);
    }
    return "".concat(path).concat(search);
  }, [issueId, mode, projectId]);
};
exports.useLocationsMapUrl = useLocationsMapUrl;
//# sourceMappingURL=useLocationsMapUrl.js.map